module.exports = __webpack_public_path__ + "img/subscribers.249aa5f3.svg";